import { KnowledgeAiDraftAuditLogEntry } from 'apis/auditLogs';

import { getLogEntryAuthorName, LogEntry } from '../activityTypes/logEntry';
import { UserLink } from '../activityTypes/userLink/userLink';

import { describeAiDraftEntry, isByAi } from './aiDraftActivity.utils';
import { AiDraftActivityDetails } from './aiDraftActivityDetails';

/** The judge's feedback is the gap it found; self-heal's, why it revised. */
const feedbackLabels: Record<string, string> = {
  human: 'Feedback',
  judge: 'Gap found',
  selfHealingStale: 'Reason',
  selfHealingRebase: 'Reason',
};

type AiDraftActivityEntryProps = {
  readonly entry: KnowledgeAiDraftAuditLogEntry;
};

/** One change to an AI draft, on the activity log's timeline. */
export const AiDraftActivityEntry = ({
  entry,
}: AiDraftActivityEntryProps): JSX.Element => {
  const { icon, text } = describeAiDraftEntry(entry);

  const authorName = getLogEntryAuthorName(entry);
  const author = isByAi(entry) ? (
    'AI'
  ) : authorName ? (
    <UserLink userId={entry.author.id}>{authorName}</UserLink>
  ) : (
    'An agent'
  );

  const details =
    entry.activity_type === 'AI_DRAFT_UPSERTED' &&
    (entry.feedback || entry.settings || entry.internal_only != null)
      ? entry
      : undefined;

  return (
    <LogEntry
      entry={entry}
      icon={icon}
      text={text(author)}
      isExpandable={!!details}
      trackExpanded={false}
    >
      {details && (
        <AiDraftActivityDetails
          feedback={details.feedback}
          feedbackLabel={feedbackLabels[details.reason ?? ''] ?? 'Feedback'}
          settings={details.settings}
          conversationId={details.initiated_from_conversation_id}
          similarConversationIds={details.similar_conversations_found}
          internalOnly={details.internal_only}
        />
      )}
    </LogEntry>
  );
};
